import { render } from "./AposResetPasswordForm.vue?vue&type=template&id=ac1fcc12&scoped=true"
import script from "./AposResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./AposResetPasswordForm.vue?vue&type=script&lang=js"

import "./AposResetPasswordForm.vue?vue&type=style&index=0&id=ac1fcc12&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac1fcc12"],['__file',"login/ui/apos/components/AposResetPasswordForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ac1fcc12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ac1fcc12', __exports__)) {
    api.reload('ac1fcc12', __exports__)
  }
  
  module.hot.accept("./AposResetPasswordForm.vue?vue&type=template&id=ac1fcc12&scoped=true", () => {
    api.rerender('ac1fcc12', render)
  })

}


export default __exports__